/**
 * Components for ewx.
 *
 * This file is dynamically generated by Webpack during the bundling process.
 */

import { cHeader } from './tools/shared/cHeader/cHeader';
import { cToc } from './tools/shared/cToc/cToc';
import { cTocTabPanel } from './tools/shared/cTocTabPanel/cTocTabPanel';
import { cTocContentsTab } from './tools/shared/cTocContentsTab/cTocContentsTab';
import { cTocContainer } from './tools/shared/cTocContainer/cTocContainer';
import { cDatasetToc } from './tools/shared/cDatasetToc/cDatasetToc';
import { cRegionTool } from './tools/shared/cRegionTool/cRegionTool';
import { cLayersToc } from './tools/shared/cLayersToc/cLayersToc';
import { cAddWMSLayerTool } from './tools/shared/cAddWMSLayerTool/cAddWMSLayerTool';
import { cRemoveWMSLayerTool } from './tools/shared/cRemoveWMSLayerTool/cRemoveWMSLayerTool';
import { cTransparency } from './tools/shared/cTransparency/cTransparency';
import { cTocLegendTab } from './tools/shared/cTocLegendTab/cTocLegendTab';
import { cAddWMSLayerForm } from './tools/shared/cAddWMSLayerForm/cAddWMSLayerForm';
import { cRemoveWMSLayerForm } from './tools/shared/cRemoveWMSLayerForm/cRemoveWMSLayerForm';
import { cMapWindow } from './tools/shared/cMapWindow/cMapWindow';
import { cZoomToRegionTool_olext } from './tools/shared/cZoomToRegionTool/cZoomToRegionTool_olext';
import { cExtentDragBoxTool_olext } from './tools/shared/cExtentDragBoxTool/cExtentDragBoxTool_olext';
import { cPanTool_olext } from './tools/shared/cPanTool/cPanTool_olext';
import { cRevertExtentTool_olext } from './tools/shared/cRevertExtentTool/cRevertExtentTool_olext';
import { cIdentifyTool_olext } from './tools/shared/cIdentifyTool/cIdentifyTool_olext';
import { cGraphTool } from './tools/shared/cGraphTool/cGraphTool';
import { cDataDownloadBtn } from './tools/shared/cDataDownloadBtn/cDataDownloadBtn';
import { cDatePickerTool_olext } from './tools/shared/cDatePickerTool/cDatePickerTool_olext';
import { cDatasetExplorerTool_olext } from './tools/shared/cDatasetExplorerTool/cDatasetExplorerTool_olext';
import { cMapLegend_olext } from './tools/shared/cMapLegend/cMapLegend_olext';
import { cMapDownloadsTool_olext } from './tools/shared/cMapDownloadsTool/cMapDownloadsTool_olext';
import { cMapPanel } from './tools/shared/cMapPanel/cMapPanel';
import { cMapWindowChartArea } from './tools/shared/cMapWindowChartArea/cMapWindowChartArea';
import { cTabPanel } from './tools/shared/cTabPanel/cTabPanel';
import { cChartContainer } from './tools/shared/cChartContainer/cChartContainer';
import { cPeriodTypeCombo } from './tools/shared/cPeriodTypeCombo/cPeriodTypeCombo';
import { cYearsCombo } from './tools/shared/cYearsCombo/cYearsCombo';
import { cZonesCombo } from './tools/shared/cZonesCombo/cZonesCombo';
import { cChartTypeCombo } from './tools/shared/cChartTypeCombo/cChartTypeCombo';
import { cChartDataTruncate } from './tools/shared/cChartDataTruncate/cChartDataTruncate';
import { cChartDataTruncateReset } from './tools/shared/cChartDataTruncateReset/cChartDataTruncateReset';
import { cSpacer } from './tools/shared/cSpacer/cSpacer';
import { cDockChart } from './tools/shared/cDockChart/cDockChart';
import { cChartToolsMenu } from './tools/shared/cChartToolsMenu/cChartToolsMenu';
import { cMenuLabel } from './tools/shared/cMenuLabel/cMenuLabel';
import { cExportPNG } from './tools/shared/cExportPNG/cExportPNG';
import { cExportCSV } from './tools/shared/cExportCSV/cExportCSV';
import { cChartLegend } from './tools/shared/cChartLegend/cChartLegend';
import { cTools } from './tools/shared/cTools/cTools';
import { cSpatialLocking } from './tools/shared/cSpatialLocking/cSpatialLocking';
import { cArrangeWindows } from './tools/shared/cArrangeWindows/cArrangeWindows';
import { cFeatureInfoPanel } from './tools/shared/cFeatureInfoPanel/cFeatureInfoPanel';

export const tools = {
  cHeader,
  cToc,
  cTocTabPanel,
  cTocContentsTab,
  cTocContainer,
  cDatasetToc,
  cRegionTool,
  cLayersToc,
  cAddWMSLayerTool,
  cRemoveWMSLayerTool,
  cTransparency,
  cTocLegendTab,
  cAddWMSLayerForm,
  cRemoveWMSLayerForm,
  cMapWindow,
  cZoomToRegionTool_olext,
  cExtentDragBoxTool_olext,
  cPanTool_olext,
  cRevertExtentTool_olext,
  cIdentifyTool_olext,
  cGraphTool,
  cDataDownloadBtn,
  cDatePickerTool_olext,
  cDatasetExplorerTool_olext,
  cMapLegend_olext,
  cMapDownloadsTool_olext,
  cMapPanel,
  cMapWindowChartArea,
  cTabPanel,
  cChartContainer,
  cPeriodTypeCombo,
  cYearsCombo,
  cZonesCombo,
  cChartTypeCombo,
  cChartDataTruncate,
  cChartDataTruncateReset,
  cSpacer,
  cDockChart,
  cChartToolsMenu,
  cMenuLabel,
  cExportPNG,
  cExportCSV,
  cChartLegend,
  cTools,
  cSpatialLocking,
  cArrangeWindows,
  cFeatureInfoPanel,
};
